export interface LandingFeature {
  title: string;
  description: string;
  isComingSoon?: boolean;
}

export interface FeatureGroup {
  title: string;
  description: string;
  features: LandingFeature[];
}

export const positioningStatement =
  "InkVoyd is built for independent tattoo artists and their small teams — not studios. Everything below ships today, except where a card is marked “Coming soon”.";

export const featureGroups: FeatureGroup[] = [
  {
    title: "Capture & qualify",
    description:
      "Turn DMs and one-off emails into one structured intake process.",
    features: [
      {
        title: "Form Builder",
        description:
          "Your very own form builder. No more signing in to different websites to configure your process — everything lives in one place.",
      },
      {
        title: "Centralized Platform",
        description:
          "A centralized hub for your booking and tattooing process. No more hunting form submissions in email or appointments across calendars — it's all in one place.",
      },
      {
        title: "Transparency",
        description:
          "Accept or reject tattoo requests clearly and honestly. Rejections are a normal part of the craft, and we make them easy on your client.",
      },
    ],
  },
  {
    title: "Automate & respond",
    description:
      "Automation and reminders that keep clients moving without you babysitting the inbox.",
    features: [
      {
        title: "Automated Workflows",
        description:
          "Create automated workflows with your own customizable settings. Assign teammates to review client submissions and tattoo ideas, and have good projects passed back to you.",
      },
      {
        title: "Customer Response Time",
        description:
          "Cut the time you spend responding to customers roughly in half. Clients start a chat when they have questions — not the other way around.",
      },
      {
        title: "Appointment Reminders",
        description:
          "Send automatic appointment reminders so clients show up prepared and on time.",
      },
      {
        title: "Last Minute Cancellation",
        description:
          "When someone cancels last-minute, we automatically notify your interested clients so the slot doesn't go to waste.",
      },
    ],
  },
  {
    title: "Policies & money",
    description:
      "Protect your time with deposits and get paid without commission.",
    features: [
      {
        title: "Security Deposit & Appointment Policies",
        description:
          "Set and enforce your own security-deposit and appointment policies to your needs, so no-shows stop costing you a day.",
      },
      {
        title: "Multiple Payment Plans",
        description:
          "We've integrated with Stripe so payments can go straight to your bank account. We only take a flat fee you can pass on to clients — no commission.",
        isComingSoon: true,
      },
    ],
  },
  {
    title: "Team & growth",
    description:
      "Grow your booking pipeline with a team and a community around your work.",
    features: [
      {
        title: "Team Management",
        description:
          "Assign each teammate a responsibility in your booking process — form submission review, form creation, calendar appointments, and more.",
      },
      {
        title: "Traveling Tattoo Artist",
        description:
          "Planning a guest spot or tour? Network with other artists on the platform and let the software coordinate with your clients.",
      },
      {
        title: "Community Building",
        description:
          "Build a network with your clients and fellow artists. Share upcoming flash sales, deals, tours, and more.",
      },
      {
        title: "Social Media Integration",
        description:
          "Post your openings and schedule straight to your social channels automatically.",
        isComingSoon: true,
      },
      {
        title: "Feedback",
        description:
          "We listen and we ship. Have an idea or something that feels clunky? The founder will work with you one-on-one to make sure your needs are met.",
      },
    ],
  },
];
